import { CapacitieApi } from '@/apis';
import { Capacitie } from '@/types/capacitie';
import { ResponseData } from '@/types/http';
import { TableState } from '@tanstack/react-table';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';

export default class CapacitieStore extends BaseStore {
    capacitieList: Capacitie[] = [];
    api: CapacitieApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            capacitieList: observable,
            getCapacitieList: flow.bound
        });
        this.api = new CapacitieApi();
    }

    *getCapacitieList(searchParams?: any, paging?: TableState) {
        try {
            const payload = { ...{ sortKey: 'id', sortDir: 'asc' }, ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...searchParams };
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getCapacitieList, payload);
            if (res.ok) {
                this.capacitieList = res?.data?.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.paginate)
                };
                this.totalRecord = res.data?.paginate?.totalRecord;
                return res?.data;
            }
        } catch (error) {
        }
    }

    clean(): void {
        super.clean();
        this.capacitieList = [];
    }
}
